export const questionnaire = {
  "questionnaire_title": "الاستبيانات",
  "questionnaire_point": "نقاط",
  "questionnaire_questionnaire": "الأسئلة",
  "questionnaire_minutes": "دقائق",
  "questionnaire_continue": "استمر",
  "questionnaire_start": "ابدأ"
}
